import { render, staticRenderFns } from "./TechSummary.vue?vue&type=template&id=32ba7691"
import script from "./TechSummary.vue?vue&type=script&lang=js"
export * from "./TechSummary.vue?vue&type=script&lang=js"
import style0 from "./TechSummary.vue?vue&type=style&index=0&id=32ba7691&prod&lang=css"
import style1 from "./TechSummary.vue?vue&type=style&index=1&id=32ba7691&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports